var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"display-only",attrs:{"readonly":"","label":_vm.label,"value":_vm.value,"placeholder":_vm.placeholder,"hide-details":"auto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }